export const INIT_STACKUP_DATA = 'fastpi/init_stackup_data';
export const CHANGE_STACKUP_TABLE = 'fastpi/change_stackup_table';
export const SETTING_UNIT = 'fastpi/setting_unit';